import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';

export const CouponTriggerWrapper = styled(Stack)`
  border-radius: 4px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.skyblue_50};
  }
`;

export const CouponContainer = styled(Stack)`
  opacity: 0;

  transition: all ease-in-out 0.3s;
  visibility: hidden;

  &.is-visible {
    opacity: 1;
    visibility: visible;
  }
`;

export const RotateArrowWrapper = styled.div`
  height: fit-content;
  transition: all ease-in-out 0.3s;

  &.is-top {
    rotate: calc(180deg);
  }
`;
